export const MAX_CONTENT_WIDTH = '960px';

export const MAX_TABLET_WIDTH = '600px';
